import { render } from "./ImagePlaceholder.vue?vue&type=template&id=948b795c"
import script from "./ImagePlaceholder.vue?vue&type=script&lang=js"
export * from "./ImagePlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__